"use strict";
/*
 * Created on 16. 9. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ShelfReportRow_1 = require("../model/ShelfReportRow");

var ShelfReportRowConverter_1 = require("./ShelfReportRowConverter");
/**
 * @author Radek Beran
 */


var ShelfReportRowConverterImpl =
/*#__PURE__*/
function (_ShelfReportRowConver) {
  _inherits(ShelfReportRowConverterImpl, _ShelfReportRowConver);

  function ShelfReportRowConverterImpl() {
    _classCallCheck(this, ShelfReportRowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShelfReportRowConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(ShelfReportRowConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ShelfReportRow_1.ShelfReportRow(ShelfReportRow_1.ShelfReportRow.schema.id.valueOf(conversions.documentToClassId(source)), // promotion
      ShelfReportRow_1.ShelfReportRow.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), ShelfReportRow_1.ShelfReportRow.schema.promotionExtId.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.promotionName.valueOfField(source), // window
      ShelfReportRow_1.ShelfReportRow.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), ShelfReportRow_1.ShelfReportRow.schema.windowName.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.windowTypeIdOld.valueOf(conversions.toClassReferenceId(source.windowTypeIdOld)), ShelfReportRow_1.ShelfReportRow.schema.windowTypeIdNew.valueOf(conversions.toClassReferenceId(source.windowTypeIdNew)), ShelfReportRow_1.ShelfReportRow.schema.windowTypeChanged.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.windowStartDateOld.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.windowStartDateNew.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.windowEndDateOld.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.windowEndDateNew.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.windowDateChanged.valueOfField(source), // product
      ShelfReportRow_1.ShelfReportRow.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ShelfReportRow_1.ShelfReportRow.schema.productExtId.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.productName.valueOfField(source), // window item
      ShelfReportRow_1.ShelfReportRow.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), ShelfReportRow_1.ShelfReportRow.schema.cmForecast.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.promoVolumeOld.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.promoVolumeNew.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.promoVolumeChanged.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.systemVolumeOld.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.systemVolumeNew.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.requestSPOld.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.requestSPNew.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.requestSPChanged.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.onPictureOld.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.onPictureNew.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.onPictureChanged.valueOfField(source), // row metadata
      ShelfReportRow_1.ShelfReportRow.schema.changeDate.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.addedCreated.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.deletedCancelled.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.userId.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.userName.valueOfField(source), ShelfReportRow_1.ShelfReportRow.schema.userSurname.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      result = Object.assign(result, conversions.classToDocumentId(source));
      result = Object.assign(result, {
        // promotion
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        promotionExtId: source.promotionExtId,
        promotionName: source.promotionName,
        // window
        windowId: conversions.toDocumentReferenceId(source.windowId),
        windowName: source.windowName,
        windowTypeIdOld: conversions.toDocumentReferenceId(source.windowTypeIdOld),
        windowTypeIdNew: conversions.toDocumentReferenceId(source.windowTypeIdNew),
        windowTypeChanged: source.windowTypeChanged,
        windowStartDateOld: source.windowStartDateOld !== null ? conversions.fromDate(source.windowStartDateOld) : null,
        windowStartDateNew: source.windowStartDateNew !== null ? conversions.fromDate(source.windowStartDateNew) : null,
        windowEndDateOld: source.windowEndDateOld !== null ? conversions.fromDate(source.windowEndDateOld) : null,
        windowEndDateNew: source.windowEndDateNew !== null ? conversions.fromDate(source.windowEndDateNew) : null,
        windowDateChanged: source.windowDateChanged,
        // product
        productId: conversions.toDocumentReferenceId(source.productId),
        productExtId: source.productExtId,
        productName: source.productName,
        // window item
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        cmForecast: source.cmForecast !== null ? conversions.fromBigNumber(source.cmForecast) : null,
        promoVolumeOld: source.promoVolumeOld !== null ? conversions.fromBigNumber(source.promoVolumeOld) : null,
        promoVolumeNew: source.promoVolumeNew !== null ? conversions.fromBigNumber(source.promoVolumeNew) : null,
        promoVolumeChanged: source.promoVolumeChanged,
        systemVolumeOld: source.systemVolumeOld !== null ? conversions.fromBigNumber(source.systemVolumeOld) : null,
        systemVolumeNew: source.systemVolumeNew !== null ? conversions.fromBigNumber(source.systemVolumeNew) : null,
        requestSPOld: source.requestSPOld,
        requestSPNew: source.requestSPNew,
        requestSPChanged: source.requestSPChanged,
        onPictureOld: source.onPictureOld,
        onPictureNew: source.onPictureNew,
        onPictureChanged: source.onPictureChanged,
        // row metadata
        changeDate: conversions.fromDate(source.changeDate),
        addedCreated: source.addedCreated,
        deletedCancelled: source.deletedCancelled,
        userId: source.userId,
        userName: source.userName,
        userSurname: source.userSurname
      });
      return result;
    }
  }]);

  return ShelfReportRowConverterImpl;
}(ShelfReportRowConverter_1.ShelfReportRowConverter);

exports.ShelfReportRowConverterImpl = ShelfReportRowConverterImpl;